<template>
  <div class="login_container">
    <img class="login_title" src="../assets/images/login_title.png" />
    <div class="login_box">
      <!--<div class="account-register">-->
      <!--  {{ $t("New User") }}-->
      <!--  &lt;!&ndash; <span-->
      <!--    style="color: #619a37"-->
      <!--    @click="$router.push(`/register`)"-->
      <!--    >{{ $t("Join Free2") }}</span-->
      <!--  > &ndash;&gt;-->
      <!--</div>-->
      <el-tabs
        style="position: relative"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="$t('Password')" name="pwdlogin">
          <el-form
            class="login-form"
            label-position="left"
            :rules="rules"
            ref="loginForm"
            label-width="0"
            :model="loginForm"
            :key="activeName"
          >
            <el-form-item class="form-item" prop="userName">
              <el-input
                v-model="loginForm.userName"
                :placeholder="$t('placeholder_username')"
              ></el-input>
            </el-form-item>
            <el-form-item class="form-item" prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                :placeholder="$t('placeholder_password')"
              ></el-input>
            </el-form-item>
            <!--<div class="drag">-->
            <!--  <div class="drag_bg"></div>-->
            <!--  <div class="drag_text">{{ confirmWords }}</div>-->
            <!--  <div-->
            <!--    @mousedown="mousedownFn($event)"-->
            <!--    class="handler handler_bg"-->
            <!--  ></div>-->
            <!--</div>-->
            <div class="button-wrap" @click="login">
              <span v-if="!loginLoading">{{ $t("Sign In") }}</span>
              <i v-if="loginLoading" class="el-icon-loading"></i>
            </div>
            <div class="btn-option row-between">
              <el-checkbox v-model="checked"
                >{{ $t("Auto Login Next Time") }}
              </el-checkbox>
              <!-- <p>{{ $t("Forget Password") }}?</p> -->
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('Mobile')" name="accountlogin">
          <el-form
            class="login-form"
            label-position="left"
            :rules="rules"
            ref="loginFormPhone"
            label-width="0"
            :model="loginFormPhone"
            :key="activeName"
          >
            <el-form-item class="form-item" prop="phone">
              <el-input
                v-model="loginFormPhone.phone"
                :placeholder="$t('Phone')"
              ></el-input>
            </el-form-item>
            <!-- <div class="drag">
              <div class="drag_bg"></div>
              <div class="drag_text">{{ confirmWords }}</div>
              <div
                @mousedown.stop="mousedownFn($event)"
                class="handler handler_bg"
              ></div>
            </div> -->
            <el-form-item class="form-item" prop="code">
              <el-input
                :placeholder="$t('Verification Code')"
                v-model="loginFormPhone.code"
              >
                <template slot="append">
                  <span
                    style="cursor: pointer; display: block; width: 100%; height: 100%;"
                    @click="sendCode"
                    >{{ btnTxt }}</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <div class="button-wrap" @click="login">
              <span v-if="!loginLoading">{{ $t("Sign In") }}</span>
              <i v-if="loginLoading" class="el-icon-loading"></i>
            </div>
            <div class="btn-option row-between">
              <el-checkbox v-model="checked"
                >{{ $t("Auto Login Next Time") }}
              </el-checkbox>
              <!-- <p>{{ $t("Forget Password") }}?</p> -->
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('New User')" name="emailLogin">
          <el-form
            class="login-form"
            label-position="left"
            :rules="rules"
            ref="loginFormEmail"
            label-width="0"
            :model="loginFormEmail"
            :key="activeName"
          >
            <el-form-item class="form-item" prop="email">
              <el-input
                v-model="loginFormEmail.email"
                :placeholder="$t('email')"
                @blur="testEmail"
              ></el-input>
            </el-form-item>
            <el-form-item class="form-item" prop="password">
              <el-input
                type="password"
                v-model="loginFormEmail.password"
                :placeholder="$t('placeholder_password')"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="form-item"
              prop="confirmPassword"
              v-if="!isEmailExist"
            >
              <el-input
                type="password"
                v-model="loginFormEmail.confirmPassword"
                :placeholder="$t('confirmPassword')"
              ></el-input>
            </el-form-item>
            <div class="button-wrap" @click="login">
              <span v-if="!loginLoading">{{ $t("Sign In") }}</span>
              <i v-if="loginLoading" class="el-icon-loading"></i>
            </div>
            <div class="btn-option row-between" v-if="false">
              <el-checkbox v-model="checked"
                >{{ $t("Auto Login Next Time") }}
              </el-checkbox>
              <!-- <p>{{ $t("Forget Password") }}?</p> -->
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="site-container">
      <div class="site-info">
        <div style="margin-bottom: 14px; font-size: 16px; cursor: pointer">
          {{ $t("About Us") }} | {{ $t("For Suppliers") }} |
          {{ $t("For Buyers") }} |
          <span @click="gomedia">{{ $t("Media Cooperation") }}</span> |
          {{ $t("Online Exhibition") }} | {{ $t("Send Massage") }} |
          {{ $t("Download") }}
        </div>
        <div style="font-size: 12px">
          2021 Copyright © e-chinacycle.com All rights reserved.
          沪ICP备110e-chinacycle.com All rights reserved. 沪ICP备11048102号-1
          沪公网安备 31010702001213
        </div>
      </div>
    </div>
    <!-- <div>{{$t('login')}}</div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";

import AuthenticationService from "../services/authentication";

import { EventBus } from "@/EventBus.js";
import ca from "element-ui/src/locale/lang/ca";
import fa from "element-ui/src/locale/lang/fa";
import { off } from "element-ui";

let intervalId;

export default {
  data() {
    let phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    let checkPhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    let codeReg = /^\d{4}$/;
    let checkCode = (rule, value, callback) => {
      if (!codeReg.test(value)) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    let checkEmail = (rule, value, callback) => {
      const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!value) {
        callback(new Error("请输入邮箱"));
      } else {
        if (!emailReg.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        } else {
          callback();
        }
      }
    };
    let checkConfirmPassword = (rule, value, callback) => {
      if (this.isEmailExist) {
        callback();
      } else {
        if (!value) {
          let message =
            this.$i18n.locale === "zh"
              ? "请再次输入密码"
              : "Please enter the password again.";
          callback(new Error(message));
        } else {
          if (value !== this.loginFormEmail.password) {
            let message =
              this.$i18n.locale === "zh"
                ? "两次输入的密码不一致"
                : "The passwords entered twice are inconsistent.";
            callback(new Error(message));
          } else {
            callback();
          }
        }
      }
    };
    return {
      activeName:
        this.$route.query.identity === "exhibitor"
          ? "pwdlogin"
          : "accountlogin",
      curIndex: 0,
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        phone: [{ validator: checkPhone, trigger: "blur" }],
        code: [{ validator: checkCode, trigger: "blur" }],
        email: [{ validator: checkEmail, trigger: "blur" }],
        confirmPassword: [{ validator: checkConfirmPassword, trigger: "blur" }]
      },
      loginForm: {
        userName: "",
        password: ""
      },
      loginFormPhone: {
        phone: null,
        code: null
      },
      loginFormEmail: {
        email: null,
        password: null
      },
      checked: false,
      beginClientX: 0,
      /*距离屏幕左端距离*/
      mouseMoveStata: false,
      /*触发拖动状态 判断*/
      maxwidth: 316,
      /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords: this.$t("Please drag the slider to the right side"),
      /*滑块文字*/
      confirmSuccess: false /*验证成功判断*/,
      btnTxt: this.$t("Send Code"),
      time: 60,
      loginLoading: false,
      isEmailExist: true
    };
  },
  methods: {
    ...mapActions({
      addAuthentication: "addAuthentication",
      getUserOrganization: "getUserOrganization",
      getOrganizationExhibitor: "getOrganizationExhibitor"
    }),
    handleClick(tab, event) {
      console.log($);
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
        this.time = 60;
        this.btnTxt = "获取验证码";
      }
      if (tab.name) {
        this.resetDrag();
      }
      console.log(tab, event);
    },
    gomedia() {
      this.$router.push("/commedia");
    },
    async loginFromAccount() {
      let valid = await this.$refs.loginForm.validate();
      // let { username, password } = this.loginForm;
      // let params = {
      //   username,
      //   password,
      // };
      if (valid) {
        return await this.addAuthentication({
          type: "Exhibitor",
          params: this.loginForm
        });
      }
    },
    async loginPhone() {
      let valid = await this.$refs.loginFormPhone.validate();

      console.log(valid);

      if (valid) {
        // return await sendSMS(this.loginFormPhone)

        return await this.addAuthentication({
          type: "PHONE_CODE",
          phoneNumber: this.loginFormPhone.phone,
          code: this.loginFormPhone.code
        });
      }
    },
    countDown() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
        this.time = 60;
        this.btnTxt = "获取验证码";
      }
      intervalId = setInterval(() => {
        console.log(this.time);
        this.time--;
        this.btnTxt = this.time + "s";
        if (this.time > 0 && this.time < 60) {
        } else {
          clearInterval(intervalId);
          this.time = 0;
          this.btnTxt = "获取验证码";
        }
      }, 1000);
    },
    async login() {
      this.loginLoading = true;
      try {
        let apiResponse = null;
        if (this.activeName === "pwdlogin") {
          apiResponse = await this.loginFromAccount();
        } else if (this.activeName === "emailLogin") {
          let valid = await this.$refs.loginFormEmail.validate();
          if (valid) {
            apiResponse = await this.addAuthentication({
              type: "EMAIL_PASSWORD",
              email: this.loginFormEmail.email,
              password: this.loginFormEmail.password
            });
          }
        } else {
          apiResponse = await this.loginPhone();
          console.log(apiResponse);
        }
        if (apiResponse) {
          const { type, account, token } = apiResponse;
          if (!token) return this.$message.error(apiResponse.message);
          this.$message.success("登录成功");

          // 类型展商
          localStorage.setItem("type", type);
          localStorage.setItem("account", JSON.stringify(account));
          localStorage.setItem("token", token);
          if (this.activeName == "pwdlogin") {
            const token = localStorage.getItem("token");
            window.open(
              `${process.env.VUE_APP_EXHIBITOR_MANAGE_URL}?from=forestage&token=${token}&platform=pc`,
              "_blank"
            );
          }
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else {
            this.$router.push("/");
          }
          // window.open(`${process.env.VUE_APP_EXHIBITOR_MANAGE_URL}?from=forestage&token=${token}&platform=pc`, "_blank")
          // window.location.href = `${process.env.VUE_APP_EXHIBITOR_MANAGE_URL}?from=forestage&token=${token}&platform=pc`
          // if (type == "EXHIBITOR") {
          // } else if (type == "VISITOR") {
          //   this.$router.push("/");
          // } else if (type == "MEDIA") {
          //   this.$router.push("/");
          // }
        } else {
          this.$message.error("登录失败");
        }
      } catch (e) {
        console.log(e);
        if (e.status) {
          this.$message.error(e.data.message);
        }
      } finally {
        this.loginLoading = false;
      }

      // console.log(apiResponse);
    },
    mousedownFn: function(e) {
      this.mouseMoveStata = true;
      this.beginClientX = e.clientX;
    }, //按下滑块函数
    resetDrag() {
      console.log(typeof $);
      console.log("-------------------resetDrag");
      this.mouseMoveStata = false;
      $("body").on("mousemove", e => {
        //拖动，这里需要用箭头函数，不然this的指向不会是vue对象
        if (this.mouseMoveStata) {
          var width = e.clientX - this.beginClientX;
          if (width > 0 && width <= this.maxwidth) {
            $(".handler").css({
              left: width
            });
            $(".drag_bg").css({
              width: width
            });
          } else if (width > this.maxwidth) {
            console.log("-----------------------执行了");
            this.successFunction();
          }
        }
      });
      $("body").on("mouseup", e => {
        //鼠标放开
        this.mouseMoveStata = false;
        var width = e.clientX - this.beginClientX;
        if (width < this.maxwidth) {
          $(".handler").css({
            left: 0
          });
          $(".drag_bg").css({
            width: 0
          });
        }
      });
      $(".handler")
        .removeClass("handler_ok_bg")
        .addClass("handler_bg");
      this.confirmWords = this.$t("Please drag the slider to the right side");
      $(".drag").css({
        "background-color": "#e8e8e8",
        color: "black"
      });
      $(".drag_bg").css({
        "background-color": "#619a37"
      });
      $(".handler").css({
        left: 0
      });
      $(".drag_bg").css({
        width: 0
      });

      this.confirmSuccess = false;
    },
    async sendCode() {
      await AuthenticationService.addAuthenticationPhoneVerificationCode({
        number: this.loginFormPhone.phone
      });
      this.countDown();
      // const res = await sendSMS(this.loginFormPhone.phone);
      // if (!res) return;
      this.$message.success("短信发送成功");
    },
    async successFunction() {
      console.log("-------------------successFunction");
      $(".handler")
        .removeClass("handler_bg")
        .addClass("handler_ok_bg");
      this.confirmWords = this.$t("Verification");
      $(".drag").css({
        color: "#fff"
      });
      $(".drag").css({
        "background-color": "#619a37"
      });
      $(".handler").css({
        left: this.maxwidth
      });
      $(".drag_bg").css({
        width: this.maxwidth
      });
      $("body").unbind("mousemove");
      $("body").unbind("mouseup");
      this.confirmSuccess = true;
      this.countDown();
      await AuthenticationService.addAuthenticationPhoneVerificationCode({
        number: this.loginFormPhone.phone
      });
      // const res = await sendSMS(this.loginFormPhone.phone);
      // if (!res) return;
      this.$message.success("短信发送成功");
    }, //验证成功函数
    async testEmail() {
      let emailValidate = false;
      this.$refs.loginFormEmail.validateField("email", message => {
        if (!message) {
          emailValidate = true;
        }
      });
      if (!emailValidate) {
        return;
      }
      const res = await AuthenticationService.testEmailExist(
        this.loginFormEmail.email
      );
      console.log(res);
      this.isEmailExist = res;
      if (!this.isEmailExist) {
        this.$message.warning("邮箱未注册，请输入密码进行注册");
      }
    }
  },
  created() {
    EventBus.$emit("switchTab", -1);
  },
  mounted() {
    $("body").on("mousemove", e => {
      // console.log("mousemove", this.mouseMoveStata);
      //拖动，这里需要用箭头函数，不然this的指向不会是vue对象
      if (this.mouseMoveStata) {
        var width = e.clientX - this.beginClientX;
        if (width > 0 && width <= this.maxwidth) {
          $(".handler").css({
            left: width
          });
          $(".drag_bg").css({
            width: width
          });
        } else if (width > this.maxwidth) {
          this.successFunction();
        }
      }
    });
    $("body").on("mouseup", e => {
      //鼠标放开
      this.mouseMoveStata = false;
      var width = e.clientX - this.beginClientX;
      if (width < this.maxwidth) {
        $(".handler").css({
          left: 0
        });
        $(".drag_bg").css({
          width: 0
        });
      }
    });
  },
  beforeDestroy() {
    clearInterval(intervalId);
  }
};
</script>
<style lang="less" scoped>
.login_container {
  background-image: url("../assets/images/login_bg.png");
  background-size: contain;
  background-position: center;
  background-color: #0d143d;
  background-repeat: no-repeat;
  height: 100vh;
}

.content {
  padding: 20px;
  max-width: 1200px;
  margin: 80px auto 0;
}

.login_title {
  width: 1200px;
  margin: 0 auto;
  height: 400px;
  display: flex;
}

.login_box {
  width: 450px;
  height: 447px;
  background: #ffffff;
  margin: 0 auto;
  position: relative;
  top: -120px;
  padding: 40px 50px;
  box-sizing: border-box;
}

.account-register {
  position: absolute;
  right: 50px;
  top: 50px;
  z-index: 99;
  font-size: 14px;
  cursor: pointer;
}

/deep/ .el-tabs__active-bar {
  background-color: #619a37 !important;
}

/deep/ .el-tabs__item.is-active {
  color: #444;
}

/deep/ .el-tabs__item.is-active:hover {
  color: #444 !important;
}

/deep/ .el-tabs__item {
  color: #999999;
}

.button-wrap {
  background-color: #619a37;
  color: #fff;
  text-align: center;
  padding: 14px 0;
  font-size: 16px;
  cursor: pointer;
}

.btn-option {
  margin: 20px 0;

  p {
    font-size: 14px;
    font-family: FZLanTingHei-R-GB18030;
    font-weight: 400;
    color: #999999;
  }
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #619a37;
  border-color: #619a37;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #619a37;
}

/deep/ .el-input__inner {
  background-color: #f4f4f4;
}

.drag {
  border-radius: 5px;
  position: relative;
  background-color: #e8e8e8;
  width: 100%;
  height: 34px;
  margin-top: 30px;
  margin-bottom: 30px;
  line-height: 34px;
  text-align: center;
}

.handler {
  border-radius: 5px;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 40px;
  height: 32px;
  border: 1px solid #ccc;
  cursor: move;
}

.handler_bg {
  background: #fff
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==")
    no-repeat center;
}

.handler_ok_bg {
  background: #fff
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==")
    no-repeat center;
}

.drag_bg {
  border-radius: 5px;
  background-color: #619a37;
  height: 34px;
  width: 0px;
}

.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}

.site-container {
  background: rgba(68, 68, 68, 0.6);
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
}

.site-info {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 19px 0;

  div {
    color: #ffffff;
  }
}
</style>

<style lang="less" scoped>
// tab样式覆写
/deep/ .el-tabs__nav {
  width: 100%;
  //#tab-emailLogin {
  //  float: right;
  //}
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue